module.exports = __webpack_public_path__ + "img/Multinskie ozera.3a353176.jpg";